'use strict';

DoohApps
    .factory('Hub', ['$location', '$filter', 'DoohConfig', function ($location, $filter, DoohConfig) {
        var handlers = [];
        var group;
        var user;
        var HubState = 'Pending';
        var chat = $.connection.doohAppsHub;

        chat.client.screenConnected = function (msg) {
            void 0;
            handle('screenConnected', msg);
        };

        chat.client.screendisconnected = function (msg) {
            void 0;
            handle('screendisconnected', msg);
        }

        chat.client.responseScreenShot = function (msg) {
            void 0;
            handle('responseScreenShot', msg);
        }

        chat.client.updateRunningSchedule = function (msg) {
            handle('updateRunningSchedule', msg);
        }

        chat.client.downloadingFilesComplete = function (msg) {
            handle('downloadingFilesComplete', msg);
        }

        chat.client.downloadingCamapaignFilesComplete = function (msg) {
            handle('downloadingCamapaignFilesComplete', msg);
        }

        chat.client.filesDownloading = function (msg) {
            handle('filesDownloading', msg);
        }

        chat.client.errorDownloadingFile = function (msg) {
            handle('errorDownloadingFile', msg);
        }
                
        chat.client.deviceMoving = function (msg) {
            handle('deviceMoving', msg);
        };

        chat.client.updateDeviceVersion = function (msg) {
            handle('deviceVersion', msg);
        };

        chat.client.errorUpdateDevice = function (msg) {
            handle('ErrorUpdateDevice', msg);
        };

        chat.client.deviceUpgraded = function (msg) {
            handle('deviceUpgraded', msg);
        };

        chat.client.scheduleAdded = function (msg) {
            handle('scheduleAdded', msg);
        };

        chat.client.scheduleUpdatedFront = function (msg) {
            handle('scheduleUpdated', msg);
        };

        chat.client.schedulesRemoved = function (msg) {
            handle('schedulesRemoved', msg);
        };

        chat.client.deviceAdded = function (msg) {
            handle('deviceAdded', msg);
        }

        chat.client.deviceNameUpdated = function (msg) {
            handle('deviceNameUpdated', msg);
        }

        chat.client.deviceRemoved = function (msg) {
            handle('deviceRemoved', msg);
        }

        $.connection.hub.stateChanged(function (change) {
            if (change.newState === $.connection.connectionState.connected) {
                HubState = 'Disconnected';
            }
        });

        $.connection.hub.reconnecting(function () {
            HubState = 'Reconnecting';
            void 0;
        });

        $.connection.hub.reconnected(function () {
            HubState = 'Reconnected';
            void 0;
        });

        $.connection.hub.disconnected(function () {
            HubState = 'Disconnected';
            void 0;
        });

        window.setInterval(function () { if (!navigator.onLine) HubState = 'Disconnected'; }, 1000);
        window.setInterval(function () {
            if ($.connection.hub != undefined) {
                if (HubState != 'Connected') {
                    StartHub();
                }
            }
        }, 1000);

        function StartHub() {
            $.connection.hub.url = DoohConfig.SignalrUrl;
            $.connection.hub.qs = 'CompanyId=' + group + '&Key=U' + user + '&Type=WebUser';
            chat = $.connection.doohAppsHub;

            $.connection.hub.start({ pingInterval: 15000 })
             .done(function () {
                 HubState = 'Connected';
                 void 0;
             })
             .fail(function (a) {
                 HubState = 'Disconnected';
                 void 0;
                 void 0;
             });
        }

        function handle(event, msg) {
            handlers[event] = handlers[event] || [];
            handlers[event].forEach(function (handler) {
                handler(msg);
            });
        }


        function setHandlers(list) {
            angular.forEach(list, function (handler, event) {
                on(event, handler);
            });
        }

        function removeHandlers(list) {
            angular.forEach(list, function (handler, event) {
                off(event, handler);
            });
        }

        function on(event, handler) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        }

        function off(event, handler) {
            handlers[event] = handlers[event].filter(function (h) {
                return h !== handler;
            });
        }

        return {
            Start: function (_group, _user) {
                group = _group;
                user = _user;
                StartHub();
            },
            Stop: function () {
                group = undefined;
                user = undefined;
                $.connection.hub.stop();
            },
            State: HubState,
            on: on,
            off: off,
            setHandlers: setHandlers,
            removeHandlers: removeHandlers
        }

    }]);

